// extracted by mini-css-extract-plugin
module.exports = {"container":"StickyNav_container__2BUCM","top":"StickyNav_top__3mbNt","bottom":"StickyNav_bottom__SjQ4X","faded":"StickyNav_faded__2Pm2u"};